import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {UserProgress, UserStats} from "../api-course-data/user-state-dto";
import {ApiUserProgressProvider} from "../api-user-progress/api-user-progress";
import {CourseVideo} from "../../models/course-video";

/*
  Generated class for the UserProgressStateProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class UserProgressStateProvider {

  constructor(private apiUserProgress: ApiUserProgressProvider) {
  }

  currentProgress: UserProgress;
  recentStats: UserStats[];

  triggerProgressUpdate() {
    if(this.currentProgress && this.currentProgress.isFinished()) {
      this.currentProgress.video._userStatus = 3;
      this.currentProgress.video.module._userClosed = 0;
      this.currentProgress.video.module.videos.map(row => {
        if(row._userStatus == 3) {
          this.currentProgress.video.module._userClosed++;
          console.log(this.currentProgress.video.module, row);
        }
      })
    }
    this.apiUserProgress.updateProgress(this.currentProgress);
    console.log('send update');
  }
  triggerVideoPlusUpdate(video: CourseVideo, status) {
    if(!status) {
      status = 3;
    }
    this.apiUserProgress.updateVideoPlusStatus(video.id, status);
    video._userStatus = status;
    console.log('send update');
  }



}



// WEBPACK FOOTER //
// ./src/providers/user-progress-state/user-progress-state.ts